import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

export default function BigBotEmbed() {
  const { user } = useSelector((state) => state.auth);
  const intl = useIntl();
  const locale = user?.attributes?.locale || intl.locale || 'es';
  const configuredRef = useRef(false);
  const [hasError, setHasError] = useState(false);
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    if (hasError) {
      return;
    }

    const loadScript = () => {
      if (
        scriptLoadedRef.current ||
        document.querySelector(
          'script[src="https://bigbot-widget.bigbuy.eu/widget.iife.js"]'
        )
      ) {
        return;
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://bigbot-widget.bigbuy.eu/widget.css';
      document.head.appendChild(link);

      const script = document.createElement('script');
      script.src = 'https://bigbot-widget.bigbuy.eu/widget.iife.js';
      script.async = true;
      script.onload = () => {
        scriptLoadedRef.current = true;
        if (window.BigBot) {
          window.BigBot.configure({
            locale,
            bottomOffset: 64,
            scope: 'control_panel',
            user: user
              ? {
                  id: user.id,
                  email: user.attributes?.email,
                  hasPack: user.attributes?.hasPack
                }
              : undefined
          });
          configuredRef.current = true;
        }
      };
      script.onerror = () => {
        setHasError(true);
        configuredRef.current = false;
      };
      document.body.appendChild(script);
    };

    loadScript();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (configuredRef.current && window.BigBot && !hasError) {
      window.BigBot.configure({
        locale,
        bottomOffset: 64,
        scope: 'control_panel',
        user: user
          ? {
              id: user.id,
              email: user.attributes?.email,
              hasPack: user.attributes?.hasPack
            }
          : undefined
      });
    }
  }, [locale, hasError, user]);

  if (hasError) {
    return null;
  }

  return null;
}
